<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Vorlagenübersicht</h2>
        <TabList class="tab-list" :items="items" :active-item-name="activeItemName"></TabList>
        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div v-else :key="1">
                <div class="spaces-filter-container">
                    <div class="top-bar-left">
                        <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
                    </div>
                    <AdaButton title="NEUE VORLAGE" to="/templates/modules/create" type="createButton"
                               icon="icon-add"></AdaButton>
                </div>
                <AdaDatatable class="listingTable" :columns="columns" :data="this.moduleTemplates" :show-search="false"
                              :size-of-page="10"
                              table-id="tModuleTable" :save-sort-state="true"
                              @rowClicked="cellClicked" :search-value="searchValue"
                              :transformers="transformers">
                    <AdaButton style="width: 100%; height: 50px" title="NEUE VORLAGE ERSTELLEN" type="fullWidthButton"
                               to="/templates/modules/create" icon="icon-add"></AdaButton>
                </AdaDatatable>
            </div>
        </transition>
        <Dialog v-if="moduleToDelete" :show-close-button="true" :show="showDeleteModuleDialog"
                :has-backdrop="true"
                @close="deleteDialogClose">
            <div class="delete-container">
                <h4>Module löschen</h4>
                <div style="margin-bottom: 30px">
                    Soll das Module: <span style="font-weight: bold">{{this.moduleToDelete.name}}</span>
                    wirklich
                    gelöscht werden?
                </div>
                <AdaButton :loading="deletingTemplate" class="btn-delete" @click="deleteClicked" title="LÖSCHEN"
                           type="createButton"></AdaButton>
            </div>
        </Dialog>
        <Dialog v-if="moduleToCopy" :show-close-button="true" :show="showCopyModuleDialog"
                :has-backdrop="true"
                @close="copyDialogClose">
            <div class="delete-container">
                <h4>Module kopieren</h4>
                <div style="margin-bottom: 30px">
                    Soll das Module: <span style="font-weight: bold">{{this.moduleToCopy.name}}</span>
                    wirklich
                    kopiert werden?
                </div>
                <AdaButton :loading="copyingTemplate" class="btn-delete" @click="copyClicked" title="KOPIEREN"
                           type="createButton"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import TabList from "../../../components/tablist/TabList";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import AdaButton from "../../../components/buttons/AdaButton";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Transformers from "../../../components/tables/Transformers";
    import Dialog from "../../../components/dialog/Dialog";
    import InputSearch from "../../../components/inputs/InputSearch";

    const ModulesRepository = RepositoryFactory.get('modules');

    export default {
        components: {
            TabList,
            BreadCrumb,
            AdaDatatable,
            AdaButton,
            Dialog,
            InputSearch
        },
        data: function () {
            return {
                showDeleteModuleDialog: false,
                moduleToDelete: null,
                showCopyModuleDialog: false,
                moduleToCopy: null,
                searchValue: '',
                columns: [
                    {
                        viewName: 'Modul',
                        propName: 'name',
                        sortable: true,
                        width: '35%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '35%'
                    },
                    {
                        viewName: 'Erstellungsdatum',
                        propName: 'created_at',
                        sortable: true,
                        width: '15%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '15%'
                    }
                ],
                items: [
                    {
                        name: 'Tracking-Listen',
                        link: '/templates/trackinglists'
                    },
                    {
                        name: 'Spaces',
                        link: '/templates/spaces'
                    },
                    {
                        name: 'Module',
                        link: '/templates/modules'
                    },
                    {
                        name: 'Interaktionen',
                        link: '/templates/interactions'
                    }
                ],
                activeItemName: 'Module',
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'edit':
                                        res += '<span style="cursor: pointer" data-type="edit" class="margin-right hover-highlight icon icon-edit"></span>';
                                        break;
                                    case 'copy':
                                        res += '<span style="cursor: pointer" data-type="duplicate" class="margin-right hover-highlight icon icon-duplicate"></span>';
                                        break;
                                    case 'delete':
                                        res += '<span style="cursor: pointer" data-type="delete" class="margin-right hover-highlight icon icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: Transformers.dateTransformer
                    }
                ],
                loading: true,
                copyingTemplate: false,
                deletingTemplate: false,
            }
        },
        name: "TemplateModules",
        mounted() {
            this.fetchModules();
        },
        computed: {
            moduleTemplates() {
                return this.$store.state.modules.templateModules;
            },
        },
        methods: {
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'editmoduletemplate', params: {id: data.row.id}});
                        break;
                    case 'duplicate':
                        this.moduleToCopy = data.row;
                        this.showCopyModuleDialog = true;
                        break;
                    case 'delete':
                        this.moduleToDelete = data.row;
                        this.showDeleteModuleDialog = true;
                        break;
                    default:
                        this.$router.push({name: 'editmoduletemplate', params: {id: data.row.id}});
                        break;
                }
            },
            async fetchModules() {
                await this.$store.dispatch('modules/fetchTemplateModules', true);
                this.loading = false;
            },
            async fetchCopyModule() {
                try {
                    await ModulesRepository.copyModule(this.moduleToCopy.id);
                    this.$noty.success('Modulvorlage erfolgreich kopiert.');
                    this.moduleToCopy = null;
                    this.showCopyModuleDialog = false;
                    this.loading = true;
                    this.fetchModules();
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Modulvorlage konnte nicht kopiert werden.');
                }
                this.copyingTemplate = false;
            },
            async fetchDeleteModule() {
                try {
                    await ModulesRepository.deleteModule(this.moduleToDelete.id);
                    this.$noty.success('Modulvorlage erfolgreich gelöscht.');
                    this.moduleToDelete = null;
                    this.showDeleteModuleDialog = false;
                    this.fetchModules();
                    this.loading = true;
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Modulvorlage konnte nicht gelöscht werden.');
                }
                this.deletingTemplate = false;
            },
            copyClicked() {
                this.copyingTemplate = true;
                this.fetchCopyModule();
            },
            copyDialogClose() {
                this.showCopyModuleDialog = false;
            },
            deleteClicked() {
                this.deletingTemplate = true;
                this.fetchDeleteModule();
            },
            deleteDialogClose() {
                this.showDeleteModuleDialog = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .spaces-filter-container {
        width: 100%;
        background-color: white;
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 12px;
    }

    .tab-list {
        margin-bottom: 20px;
    }

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
    }

    .btn-delete {
        width: fit-content;
    }

    h4 {
        margin-top: 0;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }
</style>